// extracted by mini-css-extract-plugin
export default {"products":"ProductList_products__4Q4+l","emptyProducts":"ProductList_emptyProducts__fbyjJ","btn":"ProductList_btn__Rdc6z","emptyNotif":"ProductList_emptyNotif__oQOFZ"};